// extracted by mini-css-extract-plugin
export var root = "styles-module--root--32Dfp";
export var content = "styles-module--content--35Yfe";
export var description = "styles-module--description--36egy";